import { MenuProps } from 'antd';

import { Link } from 'react-router-dom';
import { menuItemsProps } from './projectInterface';

export const background = [
  {
    photo: '',
  },
  {
    photo: '',
  },
  {
    photo: '',
  },
  {
    photo: '',
  },
  {
    photo: '',
  },
];

export const menuItems = [
  {
    title: 'HR Tracking',
    label: 'HR TRACKING',
    image: '/icons/hr_tracking.svg',
    items: [
      {
        title: 'Employee Directory',
        route: '/employee_directory',
        disabled: false,
      },
      {
        title: 'On-Off Boarding Management',
        route: '/on_offboarding',
        disabled: false,
      },
    ],
    disabled: false,
    choice: false,
  },
  {
    title: 'Staff Leave & Absences',
    label: 'STAFF LEAVE & ABSENCE',
    image: '/icons/staff_leave.svg',
    items: [
      {
        title: 'Staff & Leave Calendar',
        route: '/staff_leave_calendar',
        disabled: false,
      },
      {
        title: 'My Requests',
        route: '/my_request',
        disabled: false,
      },
      {
        title: 'My Balance',
        route: '/my_balance',
        disabled: false,
      },
      {
        title: 'Request Approval',
        route: '/request_approval',
        disabled: false,
      },
    ],
    disabled: false,
  },
  {
    title: 'Time & Activites',
    label: 'TIME & ACTIVITES',
    image: '/icons/time.svg',
    items: [],
    disabled: true,
    choice: false,
  },
  // {
  // title: 'EXPENSE REPORT',
  // image: '/icons/export.svg',
  // items: [],
  // disabled: true,
  // choice: false,
  // },
  // {
  // title: 'PLANNING',
  // image: '/icons/planning.svg',
  // items: [],
  // disabled: true,
  // choice: false,
  // },
  // {
  // title: 'PAYROLL',
  // image: '/icons/payroll.svg',
  // items: [],
  // disabled: true,
  // choice: false,
  // },
  // {
  // title: 'INTERVIEWS',
  // image: '/icons/interviews.svg',
  // items: [],
  // disabled: true,
  // choice: false,
  // },
  // {
  // title: 'WELL-BEING',
  // image: '/icons/well_being.svg',
  // items: [],
  // disabled: true,
  // choice: false,
  // },
];

export const phonesChoice = [
  {
    label: 'Work',
    value: 'work',
  },
  {
    label: 'Mobile',
    value: 'mobile',
  },
  {
    label: 'Personal',
    value: 'personal',
  },
  {
    label: 'Standard',
    value: 'standard',
  },
  {
    label: 'Secretary',
    value: 'secretary',
  },
  {
    label: 'Fax',
    value: 'fax',
  },
  {
    label: 'In case of emergency',
    value: 'emergency',
  },
];
export const AddressesChoice = [
  {
    label: 'Main',
    value: 'main',
  },
  {
    label: 'Invoicing',
    value: 'invoicing',
  },
  {
    label: 'Shipping',
    value: 'shipping',
  },
  {
    label: 'Personal',
    value: 'personal',
  },
  {
    label: 'Health Center at Work',
    value: 'health_center_at_work',
  },
];

export const adminArea: menuItemsProps[] = [
  {
    title: 'Admin Area',
    items: [
      {
        title: 'General Settings',
        route: '/general_settings',
        disabled: false,
      },
      {
        title: 'Staff Leave & Absences',
        route: '/staff_leave_&_absences',
        disabled: false,
      },
      {
        title: 'HR Tracking',
        route: '/hr_tracking',
        disabled: false,
      },
      {
        title: 'Time & Activities',
        route: '',
        disabled: true,
      },
    ],
  },
];

export const items: MenuProps['items'] = [
  {
    key: '1',
    icon: <img src="/assets/book.png" alt="Hr Tracking" />,
    label: 'HR Tracking',
    children: [
      {
        key: '1-1',
        label: <Link to={'/employee_directory'}>Employee directory</Link>,
        icon: <img src="/icons/contact book2.svg" alt="Hr Tracking" />,
      },
    ],
  },
  {
    key: '2',
    icon: <img src="/assets/calendar.png" alt="s" />,
    label: 'Staff leave & absence',
    children: [
      {
        key: '2-1',
        label: <Link to={'/staff_leave_calendar'}>Staff Leave Calendar</Link>,
        icon: <img src="/icons/schedule4.svg" alt="Hr Tracking" />,
      },
      {
        key: '2-2',
        label: <Link to={'/my_request'}>My request</Link>,
        icon: <img src="/icons/request3.svg" alt="Hr Tracking" />,
      },
      {
        key: '2-3',
        label: 'My balance',
        icon: <img src="/icons/absentism3.svg" alt="Hr Tracking" />,
      },
    ],
  },
  {
    key: '3',
    icon: <img src="/assets/clock.png" alt="s" />,
    label: 'Time & activities',
    children: [
      {
        key: '3-1',
        label: 'My timesheets',
        icon: <img src="/icons/schedule4.svg" alt="Hr Tracking" />,
      },
    ],
  },
  {
    key: '4',
    icon: <img src="/assets/clipboard.png" alt="s" />,
    label: 'Expense reports',
  },
];
export const layoutMyActions = [
  {
    id: 1,
    name: 'Create a leave request',
    image: '/icons/create_request.svg',
    routing: '/leave_request',
    disabled: false,
  },
  {
    id: 2,
    name: 'Create an expense report',
    image: '/icons/create_report.svg',
    routing: '',
    disabled: true,
  },
  {
    id: 3,
    name: 'Fill in my timesheet',
    image: '/icons/new_timesheet.svg',
    routing: '',
    disabled: true,
  },
  {
    id: 4,
    name: 'Send a request to HR',
    image: '/icons/new_send_request.svg',
    routing: '',
    disabled: true,
  },
];

export const layoutProfileAdmin = [
  {
    name: 'My Personal Space',
    icons: '',
  },
  {
    name: 'My preferences',
    icons: '/icons/new_my_preference.svg',
  },
  {
    name: 'Change Password',
    icons: '/icons/change_password.svg',
  },
  {
    name: 'Sign out',
    icons: '/icons/new_signout.svg',
  },
];
export const layoutProfileEmployee = [
  {
    name: 'My Personal Space',
    icons: '/icons/my_personal.svg',
  },
  {
    name: 'My preferences',
    icons: '/icons/new_my_preference.svg',
  },
  {
    name: 'Change Password',
    icons: '/icons/change_password.svg',
  },
  {
    name: 'Sign out',
    icons: '/icons/new_signout.svg',
  },
];

export const leave_request_select_start = [
  {
    label: 'Morning',
    value: 'morning',
    checked: false,
  },
  {
    label: 'Midday',
    value: 'midday',
    checked: false,
  },
];
export const leave_request_select = [
  {
    label: 'Morning',
    value: 'morning',
    checked: false,
  },
  {
    label: 'Midday',
    value: 'midday',
    checked: false,
  },
  {
    label: 'Evening',
    value: 'evening',
    checked: false,
  },
];
export const leave_request_select_end = [
  {
    label: 'Midday',
    value: 'midday',
    checked: false,
  },
  {
    label: 'Evening',
    value: 'evening',
    checked: false,
  },
];
export const model_applied_select = [
  {
    label: 'Select a model',
    value: 'Select a model',
  },
  {
    label: 'Select a model',
    value: 'Select a model',
  },
];
export const leave_request_type = [
  {
    label: 'Automatic',
    value: 'Automatic',
  },
  {
    label: 'Manual',
    value: 'Manual',
  },
];
export const period = [
  {
    label: 'All day',
    value: 'all_day',
  },
  {
    label: 'Morning',
    value: 'morning',
  },
  {
    label: 'Afternoon',
    value: 'afternoon',
  },
];
export const user_profile = [
  {
    label: 'Department-Manager',
    value: 'department_manager',
  },
  {
    label: 'Service-Manager',
    value: 'service_manager',
  },
  {
    label: 'Employee',
    value: 'employee',
  },
];
export const mrs = [
  {
    label: 'Male',
    value: 'male',
  },
  {
    label: 'Female',
    value: 'female',
  },
];
export const mrs1 = [
  {
    label: 'All',
    value: 'all',
  },
  {
    label: 'Male',
    value: 'male',
  },
  {
    label: 'Female',
    value: 'female',
  },
];
export const professional_status = [
  {
    label: 'Senior manager',
    value: 'senior_manager',
  },
  {
    label: 'Management',
    value: 'manager',
  },
  {
    label: 'Not Manager',
    value: 'not_manager',
  },
  {
    label: 'Worker',
    value: 'worker',
  },
  {
    label: 'Employee',
    value: 'employee',
  },
  {
    label: 'Technician',
    value: 'technician',
  },
  {
    label: 'Supervisor',
    value: 'supervisor',
  },
  {
    label: 'Streak',
    value: 'streak',
  },
  {
    label: 'Autonomous Manager',
    value: 'autonomous_manager',
  },
  {
    label: 'Other',
    value: 'other',
  },
];

export const employment_contract = [
  {
    label: 'Permanent contract',
    value: 'permanent',
  },
  {
    label: 'Fixed term contract',
    value: 'fixed_term',
  },
  {
    label: 'Temporary employment contract',
    value: 'temporary',
  },
  {
    label: 'Contract site',
    value: 'contract_site',
  },
  {
    label: 'Vocational Traineeship Agreement',
    value: 'vocational_traineeship',
  },
  {
    label: 'Youth employment contract',
    value: 'youth_employment',
  },
  {
    label: 'Internship / Traineeship agreement',
    value: 'internship_traineeship',
  },
  {
    label: 'Educational Traineeship Agreement ',
    value: 'educational_traineeship',
  },
  {
    label: 'Secondly contract',
    value: 'secondly',
  },
  {
    label: 'No contract',
    value: 'no_contract',
  },
  {
    label: 'Other',
    value: 'other',
  },
];
export const marriedStatus = [
  {
    label: 'Single',
    value: 'single',
  },
  {
    label: 'Married',
    value: 'married',
  },
  {
    label: 'Co-habiting',
    value: 'cohabiting',
  },
  {
    label: 'Divorced',
    value: 'divorced',
  },
  {
    label: 'Widowed',
    value: 'widowed',
  },
  {
    label: 'Civil partnership',
    value: 'civil_partnership',
  },
  {
    label: 'Separated',
    value: 'separated',
  },
  {
    label: 'Common law partner',
    value: 'common_law_partner',
  },
  {
    label: 'Single parent',
    value: 'single_parent',
  },
];

export const contract_start_reason = [
  {
    label: 'Hire',
    value: 'hire',
  },
  {
    label: 'Transfer',
    value: 'transfer',
  },
  {
    label: 'Replacement',
    value: 'replacement',
  },
  {
    label: 'Increase in activity',
    value: 'increase_activity',
  },
  {
    label: 'Internship/Traineeship',
    value: 'internship',
  },
  {
    label: 'Other',
    value: 'other',
  },
];

export const working_time_unit = [
  {
    label: 'Monthly Schedule',
    value: 'monthly_schedule',
  },
  {
    label: 'Fixed no of days',
    value: 'fixed_days',
  },
  {
    label: 'Annualization/Modulation',
    value: 'annualization',
  },
];

export const contractEndReasonOptions = [
  {
    label: 'Resignation',
    value: 'resignation',
  },
  {
    label: 'End of fixed term contract',
    value: 'end_fixed_term',
  },
  {
    label: 'End of probationary period',
    value: 'employer_end_probationary_period',
  },
  {
    label: 'Mutual consent',
    value: 'mutual_consent',
  },
  {
    label: 'Redundancy',
    value: 'redundancy',
  },
  {
    label: 'Mandatory retirement',
    value: 'mandatory_retirement',
  },
  {
    label: 'Retirement',
    value: 'retirement',
  },
  {
    label: 'End of contract',
    value: 'end_of_contract',
  },
  {
    label: 'End of internship/traineeship',
    value: 'end_of_internship_traineeship',
  },
  {
    label: 'Common agreement on anticipated end of fixed term contract',
    value: 'common_agreement_anticipated',
  },
  {
    label: 'Other',
    value: 'other',
  },
];

export const public_holiday = [
  {
    label: 'France',
    value: 'fr',
  },
  {
    label: 'Vietnam',
    value: 'vn',
  },
];
export const language = [
  {
    label: 'France',
    value: 'fr',
  },
  {
    label: 'English',
    value: 'en',
  },
];

export const absence_type = [
  {
    label: 'All',
    value: 'All',
    checked: false,
  },
  {
    label: 'Paid leave(25)',
    value: 'Paid leave',
    checked: false,
  },
  {
    label: 'Reduced worktime days(12)',
    value: 'Reduced worktime days',
    checked: false,
  },
];

export const periodList = [
  {
    label: '',
    value: '',
  },
  {
    label: 'Today',
    value: 'Today',
  },
  {
    label: 'Yesterday',
    value: 'Yesterday',
  },
  {
    label: 'This week',
    value: 'This week',
  },
  {
    label: 'Last week',
    value: 'Last week',
  },
  {
    label: 'Last 7 days',
    value: 'Last 7 days',
  },
  {
    label: 'This month',
    value: 'This month',
  },
  {
    label: 'The last 3 month',
    value: 'The last 3 month',
  },
  {
    label: 'This year',
    value: 'This year',
  },
  {
    label: 'Last year',
    value: 'Last year',
  },
  {
    label: 'Last 12 month',
    value: 'Last 12 month',
  },
];

export const my_request_balance_status = [
  {
    value: 'all',
    label: 'All',
  },
  {
    value: 'provision',
    label: 'Provisional',
  },
  {
    value: 'to_be_approved',
    label: 'To be approved',
  },
  {
    value: 'approved',
    label: 'Approved',
  },
];
export const leave_request_absence_type = [
  {
    label: 'Paid leave(25)',
    value: 'Paid leave(25)',
  },
  {
    label: 'Reduced worktime days (10)',
    value: 'Reduced worktime days (10)',
  },
  {
    label: 'Illness',
    value: 'Illness',
  },
  {
    label: 'Sick child leave',
    value: 'Sick child leave',
  },
  {
    label: 'Training',
    value: 'Training',
  },
];

export const employee_directory_teams = [
  {
    label: 'All',
    value: 'all',
  },
  {
    label: 'My team',
    value: 'my_team',
  },
];
export const offboarding = [
  {
    label: 'All',
    value: null,
  },
  {
    label: 'Onboarding',
    value: 'on_boarding',
  },
  {
    label: 'Offboarding',
    value: 'off_boarding',
  },
];
export const model_type_filter_options = [
  {
    label: 'All',
    value: 'all',
  },
  {
    label: 'Onboarding',
    value: 'on_boarding',
  },
  {
    label: 'Offboarding',
    value: 'off_boarding',
  },
];
export const task_status = [
  {
    label: 'To do',
    value: 'to_do',
  },
  {
    label: 'In progress',
    value: 'in_progress',
  },
  {
    label: 'Done',
    value: 'done',
  },
];
export const employee_directory_department = [
  {
    label: 'All',
    value: '',
  },
  {
    label: 'Administratif',
    value: 'Administratif',
  },
  {
    label: 'Commercial',
    value: 'Commercial',
  },
  {
    label: 'Production',
    value: 'Production',
  },
];
export const employee_directory_status = [
  {
    label: 'All',
    value: '',
  },
  {
    label: 'Present',
    value: 'present',
  },
  {
    label: 'Absent',
    value: 'absent',
  },
];
export const maskOffboarding = [
  {
    label: 'More than 1 month',
    value: '1',
  },
  {
    label: 'More than 3 month',
    value: '3',
  },
  {
    label: 'More than 6 month',
    value: '6',
  },
  {
    label: 'More than 1 year',
    value: '12',
  },
];

export const breadCrumbMyProfile = [
  {
    title: <div>Homepage/</div>,
    href: '/',
  },
  {
    title: <div>My Profile</div>,
  },
];

export const steps = [
  {
    title: '',
  },
  {
    title: '',
  },
  {
    title: '',
  },
  {
    title: '',
  },
];

export const modulesToActivate = [
  {
    label: 'HR Portal',
    value: 'HR Portal',
  },
  {
    label: 'Staff leave& absence management',
    value: 'Staff leave& absence management',
  },
  // {
  // label: 'Expense reports',
  // value: 'Expense reports',
  // },
  // {
  // label: 'Time & activities',
  // value: 'Time & activities',
  // },
];
export const platformAccess = [
  {
    label: 'User',
    value: 'access_user',
  },
  // {
  // label: 'User archived',
  // value: 'is_archived',
  // },
  {
    label: 'Don’t send email to this user',
    value: 'send_email',
  },
  // {
  // label: 'Control access via IP address',
  // value: 'control_access_ip',
  // },
];

export const vacationSchedule = [
  {
    label: 'Filter by department',
    value: 'Filter by department',
  },
  {
    label: 'Filter by structure',
    value: 'Filter by structure',
  },
];
export const modules = [
  {
    label: 'HR Tracking',
    value: 'hr_portal',
  },
  {
    label: 'Staff leave & absence management',
    value: 'absence_management',
  },
  {
    label: 'Expense reports',
    value: 'expense_report',
  },
  {
    label: 'Time & activites',
    value: 'time_activities',
  },
  {
    label: 'Feedbacks',
    value: 'feedback',
  },
];

export const adminRights = [
  {
    label: 'Modify names',
    value: 'Modify names',
  },
  {
    label: 'Display import codes in exports',
    value: 'Display import codes in exports',
  },
];
export const notiMail = [
  {
    label: 'Do not send email when there is a notification',
    value: 'Do not send email when there is a notification',
  },
  {
    label: 'Send a notification email when creating a calendar event',
    value: 'Send a notification email when creating a calendar event',
  },
];
export const notiMailIcalFormat = [
  {
    label: 'Use iCal format in approval emails for my staff leave requests',
    value: 'Use iCal format in approval emails for my staff leave requests',
  },
  {
    label:
      'Use iCal format in approval emails for staff leave requests I am copied on',
    value:
      'Use iCal format in approval emails for staff leave requests I am copied on',
  },
];

export const month = [
  { label: 'January', value: 1 },
  { label: 'February', value: 2 },
  { label: 'March', value: 3 },
  { label: 'April', value: 4 },
  { label: 'May', value: 5 },
  { label: 'June', value: 6 },
  { label: 'July', value: 7 },
  { label: 'August', value: 8 },
  { label: 'September', value: 9 },
  { label: 'October', value: 10 },
  { label: 'November', value: 11 },
  { label: 'December', value: 12 },
];
export const monthName = [
  { label: 'January', value: 1, day: 31 },
  { label: 'February', value: 2, day: 28 },
  { label: 'March', value: 3, day: 31 },
  { label: 'April', value: 4, day: 30 },
  { label: 'May', value: 5, day: 31 },
  { label: 'June', value: 6, day: 30 },
  { label: 'July', value: 7, day: 31 },
  { label: 'August', value: 8, day: 31 },
  { label: 'September', value: 9, day: 30 },
  { label: 'October', value: 10, day: 31 },
  { label: 'November', value: 11, day: 30 },
  { label: 'December', value: 12, day: 31 },
];

export const color = [
  {
    label: 'Recommended',
    colors: [
      '#000000',
      '#000000E0',
      '#000000A6',
      '#00000073',
      '#00000040',
      '#00000026',
      '#0000001A',
      '#00000012',
      '#0000000A',
      '#00000005',
      '#F5222D',
      '#FA8C16',
      '#FADB14',
      '#8BBB11',
      '#52C41A',
      '#13A8A8',
      '#1677FF',
      '#2F54EB',
      '#722ED1',
      '#EB2F96',
      '#F5222D4D',
      '#FA8C164D',
      '#FADB144D',
      '#8BBB114D',
      '#52C41A4D',
      '#13A8A84D',
      '#1677FF4D',
      '#2F54EB4D',
      '#722ED14D',
      '#EB2F964D',
    ],
  },
  {
    label: 'Recent',
    colors: [],
  },
];

export const backgrounds = [
  {
    src: '/assets/background1.svg',
  },
  {
    src: '/assets/background2.svg',
  },
  {
    src: '/assets/background4.svg',
  },

  {
    src: '/assets/background5.svg',
  },
  {
    src: '/assets/background6.svg',
  },

  {
    src: '/assets/background7.svg',
  },
  {
    src: '/assets/background8.svg',
  },
  {
    src: '/assets/background9.svg',
  },
  {
    src: '/assets/background10.svg',
  },
  {
    src: '/assets/background11.svg',
  },
];
export const colorList = [
  '#FFE0E0',
  '#FF9F9F',
  '#FF6868',
  '#E43838',
  '#F3D1FF',
  '#C670E4',
  '#9D45BC',
  '#650B85',
  '#9FA8DA',
  '#6B78C1',
  '#081C8C',
  '#3E51BB',
  '#81D4FA',
  '#44B6EA',
  '#0199DF',
  '#007BB4',
  '#80CBC4',
  '#3EB6AB',
  '#2E958B',
  '#13645C',
  '#C5E1A5',
  '#A5D271',
  '#8AB05D',
  '#596C43',
  '#FFF59D',
  '#FFEE58',
  '#FDD835',
  '#F9A825',
  '#FFCC80',
  '#FFA726',
  '#FB8C00',
  '#EF6C00',
  '#BCAAA4',
  '#8D7A73',
  '#634A42',
  '#3F241B',
  '#B0BEC5',
  '#718A97',
  '#4C6876',
  '#283D47',
];
